<template>
  <div v-if="src" class="imgBox">
    <img :src="src" alt="">
  </div>
</template>

<script>
export default {
  props: [
    'locale',
    'lang',
    'imgSrc'
  ],
  computed: {
    auth () {
      return this.$store.getters['authentication/getAuthInfo']
    }
  },
  beforeDestroy () {
    this.$store.commit('common/setMetaScale', false)
  },
  mounted () {
    this.getImageSrc()
    this.$store.commit('common/setMetaScale', true)
  },
  data () {
    return {
      src: null
    }
  },
  methods: {
    getImageSrc () {
      const src = this.imgSrc || this.$route.params.src
      this.src = src
    }
  }
}
</script>
